import { useMessageCommands } from 'matrix/commands/useMessageCommands';
import { RoomType } from 'matrix/constants';
import { useRooms } from 'matrix/hooks/useRooms';
import { useMatrixContext } from 'matrix/MatrixContext';
import { type Room } from 'matrix-js-sdk';
import { useCallback, useMemo } from 'react';
import { useMatrixStatus } from '../../matrix/hooks/useMatrixStatus';
import { useHasUnread } from '../../matrix/hooks/useNotifications';
import { RoomNames } from '../../utils/matrixClient';

export const useMatrixClient = () => {
  const { client } = useMatrixContext();
  const { markAllAsRead } = useMessageCommands();

  const hasUnread = useHasUnread({
    excludeRoomTypes: [RoomType.DM],
  });

  const { isReady } = useMatrixStatus();

  const markAllAsUnread = useCallback(async () => {
    await markAllAsRead({ excludeRoomTypes: [RoomType.DM] });
  }, [markAllAsRead]);

  return {
    client,
    isAvailable: isReady,
    markAllAsUnread,
    hasUnread,
  };
};
